import { render, staticRenderFns } from "./videoCall.vue?vue&type=template&id=0fa54d8f&scoped=true"
import script from "./videoCall.vue?vue&type=script&lang=js"
export * from "./videoCall.vue?vue&type=script&lang=js"
import style0 from "./videoCall.vue?vue&type=style&index=0&id=0fa54d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa54d8f",
  null
  
)

export default component.exports